export default {
  register: {
    title: 'Daftar',
    username: 'Nama Pengguna',
    phone: 'Nombor Telefon',
    phoneCode: 'Kod',
    email: 'E-mel',
    password: 'Kata Laluan',
    captcha: 'Captcha',
    smsCode: 'Kod SMS',
    emailCode: 'Kod E-mel',
    verificationCode: 'Kod e-mel',
    invitationCode: 'Kod Jemputan',
    loading: 'Memuatkan...',
    send: 'Hantar',
    sendCode: 'Hantar Kod',
    signUp: 'Daftar',
    contactUs: 'Hubungi Kami？',
    haveAccount: 'Sudah ada akaun?',
    signIn: 'Log Masuk',
    loginNow: 'Log Masuk',
    or: 'ATAU',
    orSignUpWith: 'Atau daftar dengan',
    methodUsername: 'Nama Pengguna',
    methodPhone: 'Telefon',
    methodEmail: 'E-mel',
    codeOptional: 'Kod (Pilihan)',
    privacyPolicy: 'Saya mengesahkan bahawa saya berumur lebih 18 tahun dan menerima',
    privacyPolicyLink: 'Dasar Privasi',
    and: 'dan',
    termsConditions: 'Terma & Syarat',
    vault: 'Peti Besi',
    receivePromos: 'Terima Promosi E-mel',
    usernameRequired: 'Nama pengguna diperlukan',
    usernameInvalid: 'Nama pengguna hanya boleh mengandungi huruf, nombor dan garis bawah',
    phoneRequired: 'Nombor telefon diperlukan',
    phoneInvalid: 'Format nombor telefon tidak sah',
    emailRequired: 'E-mel diperlukan',
    emailInvalid: 'Format e-mel tidak sah',
    passwordRequired: 'Kata laluan diperlukan',
    passwordInvalid: 'Kata laluan tidak memenuhi keperluan',
    captchaRequired: 'Captcha diperlukan',
    smsCodeRequired: 'Kod SMS diperlukan',
    emailCodeRequired: 'Kod e-mel diperlukan',
    privacyPolicyRequired: 'Sila terima Dasar Privasi dan Terma & Syarat',
    passwordHintLow: 'Sekurang-kurangnya 6 digit',
    passwordHintMedium: 'Sekurang-kurangnya 6 aksara dengan huruf dan nombor',
    passwordHintHigh: 'Sekurang-kurangnya 6 aksara dengan huruf, nombor dan simbol',
    // Format validation
    usernameFormat: 'Hanya huruf, nombor dan _',
    emailFormat: 'Format e-mel tidak sah',
    // Toast messages
    smsCodeSent: 'Kod SMS dihantar',
    emailCodeSent: 'Kod e-mel dihantar',
    smsCodeFailed: 'Gagal menghantar kod SMS',
    emailCodeFailed: 'Gagal menghantar kod e-mel',
    registerSuccess: 'Pendaftaran berjaya',
    registerFailed: 'Pendaftaran gagal',
    // Google sign in
    signInWithGoogle: 'Log masuk dengan Google+'
  }
};
